module.exports = __webpack_public_path__ + "img/verified-physical-assessment.b4296aa2.png";